module.exports = __webpack_public_path__ + "static/media/main3_zh_768-min.fc660324.png";